import * as signIn from "../redux/modules/signIn";

export const signInController = {
  /**
   * サインイン処理の実行
   * @param accountId
   * @param password
   */
  signIn: (accountId, password) => (
    dispatch,
    getState,
    { request, storage }
  ) => {
    dispatch(signIn.actions.requestSignIn());

    request({
      method: "POST",
      url: "/api/v1/action_point/sign_in/",
      data: {
        login_id: accountId,
        password: password,
      },
    })
      .then((result) => {
        if (result.data.data) {
          // Save the api token to the user's cookie.
          storage.set("reward-app-token", result.data.data.access_token, {
            secure: process.env.NODE_ENV === "production",
            expires: 30,
          });
          dispatch(signIn.actions.succeededSignInApi());
        } else {
          dispatch(signIn.actions.sendError());
        }
      })
      .catch((e) => {
        console.error(e);
        dispatch(signIn.actions.sendError());
      });
  },
};
